import { useCallback } from "react";
import { getPaymentsFinancialProgramsPaymentsGet } from "../internal/shared/api/services.gen.js";
import { CreditType, SortByPayment } from "../internal/shared/api/types.gen.js";
import { useAppSelector } from "../internal/shared/lib/store/hooks/useAppSelector.js";
import { cleanObject } from "../internal/shared/lib/utils/cleanObject.js";
import ApiService from "../internal/shared/services/ApiService.js";
import "../internal/shared/store/config/middleware/index.js";
import { selectSlice } from "../internal/shared/store/config/model/selectors/selectSlice.js";
import "../internal/shared/store/config/model/slice.js";
function useFetchPreviewFinancialProgram() {
  const { clientId, creditParamsFormatter } = useAppSelector(selectSlice);
  const fetchPreviewFinancialProgram = useCallback(
    async (choice) => {
      if (!choice.price) {
        throw new Error("Ошибка, для расчета лимитов необходима цена!");
      }
      const resolvedChoice = {
        ...choice,
        type: CreditType.ANNUITY,
        downPayment: 50,
        numberOfPeriods: 48
      };
      let filteredCreditParams = {};
      const formattedCreditParams = creditParamsFormatter(choice);
      if (typeof formattedCreditParams !== "undefined") {
        filteredCreditParams = cleanObject(formattedCreditParams, choice);
      }
      const query = {
        type: resolvedChoice.type,
        number_of_periods: resolvedChoice.numberOfPeriods,
        present_value: resolvedChoice.price,
        down_payment: resolvedChoice.downPayment,
        sort_by: SortByPayment.PAYMENT,
        ...filteredCreditParams
      };
      if (resolvedChoice.model) {
        query.model = resolvedChoice.model;
      }
      const apiClient = ApiService.getInstance().client;
      const { data: financialPrograms = [] } = await getPaymentsFinancialProgramsPaymentsGet({
        client: apiClient,
        headers: {
          "X-Client-Id": clientId
        },
        query
      });
      return {
        choice: resolvedChoice,
        program: financialPrograms[0]
      };
    },
    [creditParamsFormatter, clientId]
  );
  return [fetchPreviewFinancialProgram];
}
export {
  useFetchPreviewFinancialProgram
};
